import E404 from "../routes/Status/404.svelte"
import Index from "../routes/Index.svelte";
import Product from "../routes/Product.svelte";
import Contact from "../routes/Contact.svelte";
import Summary_1 from "../routes/Order/1-OrderDelivery.svelte";
import PaymentSuccessful from "../routes/PaymentStatus/PaymentSuccessful.svelte";
import PaymentPending from "../routes/PaymentStatus/PaymentPending.svelte";
import PaymentCancelled from "../routes/PaymentStatus/PaymentCancelled.svelte";
import DeliveryDetails_2 from "../routes/Order/2-OrderDetails.svelte";
import Completion_3 from "../routes/Order/3-OrderCompleted.svelte";
import TermsAndConditions from "../routes/TermsAndConditions.svelte";
import TransportAndDelivery from "../routes/TransportAndDelivery.svelte";
import ComplaintProcedure from "../routes/ComplaintProcedure.svelte";
import ProtectionOfPersonalData from "../routes/ProtectionOfPersonalData.svelte";
import Account from "../routes/Account/Account.svelte";
import AccountOrders from "../routes/Account/AccountOrders.svelte";
import AccountAddresses from "../routes/Account/AccountAddresses.svelte";
import AccountChangePassword from "../routes/Account/AccountChangePassword.svelte";
import AccountAddressCreate from "../routes/Account/AccountAddressCreate.svelte";
import AccountAddressDetail from "../routes/Account/AccountAddressDetail.svelte";
import AccountOrderDetail from "../routes/Account/AccountOrderDetail.svelte";
import AccountActivation from "../routes/Redirect/AccountActivation.svelte";
import Error from "../routes/Status/Error.svelte";
import Check from "../routes/Status/Check.svelte";
import ForgottenPasswordChange from "../routes/Redirect/ForgottenPasswordChange.svelte";
import Redirect_3 from "../routes/Order/3-OrderRedirect.svelte";


export default {
    "/": Index,
    "/produkt/:id": Product,
    "/kontakt": Contact,
    "/suhrn": Summary_1,
    "/dodacie-udaje": DeliveryDetails_2,
    "/dokoncenie": Completion_3,
    "/dokoncenie/platobna-brana": Redirect_3,
    "/obchodne-podmienky": TermsAndConditions,
    "/doprava-a-dodanie": TransportAndDelivery,
    "/reklamacny-poriadok": ComplaintProcedure,
    "/ochrana-osobnych-udajov": ProtectionOfPersonalData,

    "/ucet": Account,
    "/ucet/objednavky": AccountOrders,
    "/ucet/detail-objednavky/:id": AccountOrderDetail,
    "/ucet/adresy": AccountAddresses,
    "/ucet/nova-adresa": AccountAddressCreate,
    "/ucet/detail-adresy/:id": AccountAddressDetail,
    "/ucet/zmena-hesla": AccountChangePassword,

    "/overenie-uctu": AccountActivation,
    "/zabudnute-heslo": ForgottenPasswordChange,

    "/chyba": Error,
    "/uspech": Check,

    "/platba/zaplateno": PaymentSuccessful,
    "/platba/caka": PaymentPending,
    "/platba/zruseno": PaymentCancelled,

    "*": E404
}